module.exports = __webpack_public_path__ + "../resources/img/ic_refresh.74982648.svg";